import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import dayjs from "dayjs";

// Utility function to generate table headers
const generateTableHeaders = (columns) => {
  return columns
    ?.map((col) => col.title)
    .filter((header) => header !== "Actions" && header !== "Sl No");
};

// Utility function to generate table body rows
// const generateTableBody = (data, tableHeaders, fieldMapping,unitList) => {
//   return data?.map((item) => {
//     return tableHeaders?.map((header) => {
//       const field = fieldMapping[header];
//       let value = field?.includes(".")
//         ? field.split(".").reduce((obj, key) => obj && obj[key], item)
//         : item[field];
//       if (header === "Invoice Date") {
//         console.log();
//       }
//       if (header.toLowerCase()?.includes("date") && value) {
//         value = dayjs(value).format("DD-MM-YY");
//       }

//       if (field === "products") {
//         value = item?.product?.name;
//       }
//       // if (field === "units") {
//       //   value = item?.unit?.guid?.name;
//       // }
//       if (field === "units" || field === "unit") {
//   const unitGuid = item?.unit?.guid;
//   value = unitList?.find((u) => u.guid === unitGuid)?.name || "-";
// }
//       if (field === "salesPaymentType") {
//         switch (value) {
//           case 0:
//             value = "Cash";
//             break;
//           case 1:
//             value = "Credit";
//             break;
//           case 2:
//             value = "UPI";
//             break;
//           case 3:
//             value = "Card";
//             break;
//           default:
//             value = "Unknown";
//         }
//       }
//           if (field === "purchasePaymentType") {
//         switch (value) {
//           case 0:
//             value = "Cash";
//             break;
//           case 3:
//             value = "Credit";
//             break;
//           case 4:
//             value = "UPI";
//             break;
//           case 1:
//             value = "Card";
//             break;
//             case 2:
//             value = "Bank";
//             break;
//           default:
//             value = "Unknown";
//         }
//       }
//       if (field === "type") {
//         switch (value) {
//           case 0:
//             value = "Stock Adjustment";
//             break;
//           case 1:
//             value = "Damage";
//             break;
//           case 2:
//             value = "Wastage";
//             break;
//           default:
//             value = "Unknown";
//         }
//       }

//       return value;
//     });
//   });
// };

// Utility function to generate table body rows
const generateTableBody = (
  data,
  tableHeaders,
  fieldMapping,
  unitList,
  totals // ✅ added
) => {
  // ✅ Create body first
  const body = data?.map((item) => {
    return tableHeaders?.map((header) => {
      const field = fieldMapping[header];

      let value = field?.includes(".")
        ? field.split(".").reduce((obj, key) => obj && obj[key], item)
        : item[field];

      // ✅ Date formatting
      if (header.toLowerCase()?.includes("date") && value) {
        value = dayjs(value).format("DD-MM-YY");
      }

      // ✅ Product name fix
      if (field === "products") {
        value = item?.product?.name;
      }

      // ✅ Unit handling
      if (field === "units" || field === "unit") {
        const unitGuid = item?.unit?.guid;
        value = unitList?.find((u) => u.guid === unitGuid)?.name || "-";
      }

      // ✅ Sales Payment Type
      if (field === "salesPaymentType") {
        switch (value) {
          case 0:
            value = "Cash";
            break;
          case 1:
            value = "Credit";
            break;
          case 2:
            value = "UPI";
            break;
          case 3:
            value = "Card";
            break;
          default:
            value = "Unknown";
        }
      }

      // ✅ Purchase Payment Type
      if (field === "purchasePaymentType") {
        switch (value) {
          case 0:
            value = "Cash";
            break;
          case 3:
            value = "Credit";
            break;
          case 4:
            value = "UPI";
            break;
          case 1:
            value = "Card";
            break;
          case 2:
            value = "Bank";
            break;
          default:
            value = "Unknown";
        }
      }

      // ✅ Type Mapping
      if (field === "type") {
        switch (value) {
          case 0:
            value = "Stock Adjustment";
            break;
          case 1:
            value = "Damage";
            break;
          case 2:
            value = "Wastage";
            break;
          default:
            value = "Unknown";
        }
      }

      return value !== undefined ? value : "";
    });
  }) || [];

  // ✅ ADD TOTAL ROW (FIXED)
  if (totals) {
    const totalRow = tableHeaders.map((header, index) => {
      const field = fieldMapping[header];

      if (index === 0) return "Total";

      return totals[field] !== undefined
        ? Number(totals[field]).toFixed(2)
        : "";
    });

    body.push(totalRow);
  }

  return body;
};

// Excel Export
export const exportExcel = (getActiveTabData, name) => {
  const { data, columns, fieldMapping, filename,totals } = getActiveTabData();
  const tableHeaders = generateTableHeaders(columns);
  const tableBody = generateTableBody(data, tableHeaders, fieldMapping,null,totals);

  const worksheet = XLSX.utils.aoa_to_sheet([tableHeaders, ...tableBody]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

  XLSX.writeFile(workbook, `${filename || name}.xlsx`);
};

// Printable format
export const printReport = (getActiveTabData, name) => {
  const { data, columns, fieldMapping, filename,totals } = getActiveTabData();

  const printWindow = window.open("", "_blank");

  // Prepare the document for printing
  printWindow.document.write("<html><head><title>Print Report</title>");
  printWindow.document.write("<style>");
  printWindow.document.write(`
        table {
            width: 100%;
            border-collapse: collapse;
        }
        th, td {
            border: 1px solid black;
            padding: 8px;
            text-align: left;
        }
        th {
            background-color: #f2f2f2;
        }
    `);
  printWindow.document.write("</style></head><body>");
  printWindow.document.write(`<h1>${filename || name}</h1>`);

  const tableHeaders = generateTableHeaders(columns);
  let tableHTML = "<table><thead><tr>";
  tableHeaders.forEach((header) => {
    tableHTML += `<th>${header}</th>`;
  });
  tableHTML += "</tr></thead><tbody>";

  const tableBody = generateTableBody(data, tableHeaders, fieldMapping,null,totals);
  tableBody.forEach((row) => {
    tableHTML += "<tr>";
    row.forEach((cell) => {
      tableHTML += `<td>${cell !== undefined ? cell : ""}</td>`;
    });
    tableHTML += "</tr>";
  });
  tableHTML += "</tbody></table>";

  printWindow.document.write(tableHTML);
  printWindow.document.write("</body></html>");

  printWindow.document.close();
  printWindow.print();
};

// PDF Export
export const exportPDF = (getActiveTabData, name) => {
  const { data, columns, fieldMapping, filename,unitList,totals } = getActiveTabData();

  console.log("filename", filename);

  // Set orientation based on the number of columns (e.g., more than 5 columns -> landscape)
  const orientation = columns?.length > 9 ? "landscape" : "portrait";

  // Initialize jsPDF with the dynamic orientation
  const doc = new jsPDF({
    orientation: orientation,
  });

  // Generate table headers and body
  const tableHeaders = generateTableHeaders(columns);
  const tableBody = generateTableBody(data, tableHeaders, fieldMapping,unitList,totals);

  // Use autoTable to export the table
  autoTable(doc, {
    head: [tableHeaders],
    body: tableBody,
  });

  // Save the PDF
  doc.save(`${filename || name}.pdf`);
};
